import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FeatureFlagsModule } from '@wilson/feature-flags';
import { RoleAction, RolePermissionSubject, Shift } from '@wilson/interfaces';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CanAllShiftBeModifiedPipe } from '@wilson/non-domain-specific/shift-helpers/core';
import { TimelineShiftAssignService } from '../../../services/timeline-shift-assign.service';
import { TimelineMultiSelectHelperService } from '../timeline-multi-select-helper.service';
import { AuthorizationModule } from '@wilson/authorization';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { AbilityServiceSignal } from '@casl/angular';

@Component({
  selector: 'wilson-assign-multi-select-shifts-button',
  imports: [
    NzButtonModule,
    TranslateModule,
    FeatureFlagsModule,
    CanAllShiftBeModifiedPipe,
    AuthorizationModule,
    NzTooltipModule,
  ],
  providers: [TimelineShiftAssignService, TimelineMultiSelectHelperService],
  templateUrl: './assign-multi-select-shifts-button.component.html',
  styleUrl: './assign-multi-select-shifts-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignMultiSelectShiftsButtonComponent {
  @Input({ required: true }) selectedShifts!: (Shift & { id: string })[];
  @Input() isOperationOnGoing = false;
  @Output() triggerAssignMultiShifts = new EventEmitter();
  assignedUserId = '';
  protected RoleAction = RoleAction;
  protected RolePermissionSubject = RolePermissionSubject;
  protected can = inject(AbilityServiceSignal).can;
}
